import axios from 'axios';

export default {
  search: async function (request) {
    return await axios.get('api/search/search', { params: request });
  },
};
